// React
import React from 'react';

// Assets
import images from '../../../assets/img';

// Css
import './index.scss';

const DownloadDoument = (props) => {
  return (
    <div
      onClick={props.handleDownloadInvoice}
      className='download'
      tabIndex={0}
      role='button'
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ')
          props.handleDownloadInvoice();
      }}
    >
      <span className='download-file-text'>
        {props.title}{' '}
        <img
          className='download-image'
          src={images.downloadIcon}
          alt={props.title}
        />
      </span>
    </div>
  );
};

export default DownloadDoument;
